import * as React from 'react';

import { css } from '@gogame/ui/styles';

import styled from '../../styled';

const Box = styled('div')({});

//@todo rewrite project to material-ui Grid
export const LegacyBox = styled(
  React.forwardRef(
    (
      {
        children,
        inline,
        vertical,
        reverse,
        wrap,
        relative,
        grow,
        shrink,
        justify,
        align,
        order,
        basis,
        gutter,
        width,
        className = '',
        ...props
      },
      ref
    ) => (
      <Box
        {...props}
        ref={ref}
        className={gutter ? `${className} gutter` : `${className}`}
      >
        {children}
      </Box>
    )
  )
)`
  box-sizing: border-box;
  display: ${(props) => (props.inline ? 'inline-flex' : 'flex')};

  ${(props) =>
    (props.vertical || props.reverse) &&
    css`
      flex-direction: ${(props.vertical ? 'column' : 'row') +
      (props.reverse ? '-reverse' : '')};
    `};

  ${(props) =>
    css`
      flex-wrap: ${props.wrap ? `${props.wrap}` : `nowrap`};
    `};

  ${(props) =>
    props.relative &&
    css`
      position: relative;
    `};

  ${(props) =>
    props.hasOwnProperty('grow') &&
    css`
      flex-grow: ${props.grow};
    `};

  ${(props) =>
    props.hasOwnProperty('shrink') &&
    css`
      flex-shrink: ${props.shrink};
    `};

  ${(props) =>
    props.justify &&
    css`
      justify-content: ${props.justify};
    `};

  ${(props) =>
    props.align &&
    css`
      align-items: ${props.align};
    `};

  ${(props) =>
    props.order &&
    css`
      order: ${props.order};
    `};

  ${(props) =>
    props.basis &&
    css`
      flex-basis: ${props.basis};
    `};

  ${(props) =>
    props.gutter !== undefined &&
    !props.vertical &&
    css`
      &.gutter > *:first-child {
        margin-left: 0;
      }

      &.gutter > * {
        margin-left: ${props.gutter}px;
      }
    `};

  ${(props) =>
    props.gutter !== undefined &&
    props.vertical &&
    css`
      &.gutter > *:first-child {
        margin-top: 0;
      }

      &.gutter > * {
        margin-top: ${props.gutter}px;
      }
    `};

  ${(props) =>
    props.width &&
    css`
      width: ${props.width};
    `};
`;

LegacyBox.displayName = 'Box';
LegacyBox.defaultProps = {
  vertical: false,
};

export default LegacyBox;
